export default function MapIcon({ color = "#603CFF" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={{ color }}
    >
      <path
        d="M21.4613 4.65854C21.3714 4.58854 21.2668 4.53992 21.1554 4.51636C21.0439 4.49281 20.9286 4.49494 20.8181 4.5226L15.0872 5.9551L9.33563 3.07885C9.17537 2.99892 8.99181 2.97897 8.81812 3.0226L2.81812 4.5226C2.65587 4.56316 2.51183 4.65679 2.40889 4.7886C2.30595 4.92042 2.25003 5.08286 2.25 5.2501V18.7501C2.25002 18.8641 2.27601 18.9765 2.32599 19.0789C2.37598 19.1814 2.44864 19.271 2.53847 19.3412C2.62831 19.4113 2.73294 19.46 2.84442 19.4837C2.95591 19.5073 3.07131 19.5052 3.18187 19.4776L8.91281 18.0451L14.6644 20.9214C14.7688 20.9728 14.8836 20.9998 15 21.0001C15.0613 21.0001 15.1224 20.9925 15.1819 20.9776L21.1819 19.4776C21.3441 19.437 21.4882 19.3434 21.5911 19.2116C21.694 19.0798 21.75 18.9174 21.75 18.7501V5.2501C21.75 5.13603 21.724 5.02346 21.674 4.92095C21.624 4.81844 21.5512 4.7287 21.4613 4.65854ZM9 16.5001C8.93868 16.5001 8.8776 16.5077 8.81812 16.5226L3.75 17.7892V5.83604L8.91281 4.5451L9 4.58823V16.5001ZM20.25 18.1642L15.0872 19.4551L15 19.412V7.5001C15.0613 7.50037 15.1224 7.49313 15.1819 7.47854L20.25 6.21104V18.1642Z"
        fill="currentColor"
      />
    </svg>
  );
}
